export const CONTENT_WIDTH = Object.freeze({
	narrow: 5,
	wide: 8,
	full: 12,
})
